import { useState } from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/navbar/NavBar";
import Projects from "../components/sidebar/Projects";
import TeamMembers from "../components/sidebar/TeamMembers";
import Task from "../components/task/Task";
import { useGetTasksQuery } from "../features/api/apiSlice";

const Home = () => {
  const [searchItm, setSearchItm] = useState("");

  const {
    data: tasks,
    isLoading,
    isError,
    error,
  } = useGetTasksQuery(undefined, {
    selectFromResult: ({ data }) => {
      if (searchItm === "") {
        return { data };
      } else {
        return {
          data: data?.filter((t) =>
            t.taskName.toLowerCase().includes(searchItm.toLowerCase())
          ),
        };
      }
    },
  });

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (!isLoading && isError) {
    content = <p>{error?.data}</p>;
  } else if (!isLoading && !isError && tasks?.length === 0) {
    content = <p>No Tasks found!</p>;
  } else if (!isLoading && !isError && tasks?.length > 0) {
    content = tasks?.map((task) => <Task key={task.id} task={task} />);
  }

  return (
    <>
      <NavBar setSearchItm={setSearchItm} searchItm={searchItm} />

      <div className="container relative">
        <div className="sidebar">
          <Projects />
          <TeamMembers />
        </div>

        <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
          <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
            <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
              <Link to="/add" className="lws-addnew group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6 group-hover:text-indigo-500"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>

                <span className="group-hover:text-indigo-500">Add New</span>
              </Link>
            </div>

            <div className="lws-task-list">{content}</div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Home;
